import {
  Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const primeiroNome = (n) => (n || "").trim().split(/\s+/)[0] || "";

export const fornAbbr = (codigo, nome) => codigo || primeiroNome(nome);

export const FornTag = ({ codigo, nome, className = "", testid }) => {
  if (!codigo && !nome) return null;
  return (
    <span title={primeiroNome(nome)} className={`cursor-help ${className}`} data-testid={testid}>
      {fornAbbr(codigo, nome)}
    </span>
  );
};

// Abreviatura da origem (armazém); sem origem, a do fornecedor. Nome completo ao passar o rato.
export const origemAbbr = (forn, origem) => origem?.codigo || fornAbbr(forn?.codigo_interno, forn?.nome) || "";
export const origemTitulo = (forn, origem) => [forn?.nome, origem?.nome].filter(Boolean).join(" · ");

export const OrigemTag = ({ forn, origem, className = "", testid }) => {
  const txt = origemAbbr(forn, origem);
  if (!txt) return null;
  return <span title={origemTitulo(forn, origem)} className={`cursor-help ${className}`} data-testid={testid}>{txt}</span>;
};

export const OrigemPicker = ({ fornecedores, fornecedorId, origemId, onChange, className = "", testid, placeholder = "—" }) => {
  const f = fornecedores.find((x) => x.id === fornecedorId);
  const o = (f?.origens || []).find((x) => x.id === origemId);
  const falta = f && !o && (f.origens || []).length > 1;
  return (
    <Select value={fornecedorId ? `${fornecedorId}|${origemId || ""}` : ""}
      onValueChange={(v) => { const [fid, oid] = v.split("|"); onChange(fid, oid || null); }}>
      <SelectTrigger className={`${className} ${falta ? "border-amber-400 bg-amber-50" : ""}`} data-testid={testid} title={f ? origemTitulo(f, o) + (falta ? " — escolher armazém" : "") : ""}>
        <SelectValue placeholder={placeholder}>{f ? `${origemAbbr(f, o)}${falta ? " ?" : ""}` : null}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {fornecedores.map((fx) => (
          <SelectGroup key={fx.id}>
            <SelectLabel className="text-[10px] uppercase text-slate-400">{fx.nome}</SelectLabel>
            {(fx.origens || []).length
              ? fx.origens.map((ox) => (
                <SelectItem key={ox.id} value={`${fx.id}|${ox.id}`} data-testid={`opt-origem-${ox.codigo || ox.id}`}>
                  {ox.nome}{ox.codigo ? <span className="font-mono text-slate-400"> · {ox.codigo}</span> : null}
                </SelectItem>
              ))
              : <SelectItem value={`${fx.id}|`}>{fx.nome}{fx.codigo_interno ? <span className="font-mono text-slate-400"> · {fx.codigo_interno}</span> : null}</SelectItem>}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
};
